exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".calendar .alert {\n  margin-bottom: 0;\n  margin-top: 15px; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./modules/menu/css/rbc-calendar-alert.scss
// module id = 915
// module chunks = 0